// Call-control protocol carried over a PeerJS DataConnection, separate from the
// media. This is what makes "declined / busy / no answer / hung up" detectable —
// MediaConnection lifecycle alone can't distinguish those cases reliably.
//
// Flow:
//   caller opens DataConnection -> sends "ring"
//   callee -> "accept" (then caller starts the media call) | "decline" | "busy"
//   either side -> "hangup" to end an active call
//   caller -> "cancel" if it gives up before an answer

export type ControlMessage =
  | { type: "ring" }
  | { type: "accept" }
  | { type: "decline" }
  | { type: "busy" }
  | { type: "cancel" }
  | { type: "hangup" };

export function isControlMessage(data: unknown): data is ControlMessage {
  return (
    typeof data === "object" &&
    data !== null &&
    "type" in data &&
    typeof (data as { type: unknown }).type === "string"
  );
}

// How long the caller waits for an answer before giving up.
export const RING_TIMEOUT_MS = 30_000;

// How long to wait, once ICE is "disconnected", before declaring the call dead.
export const RECONNECT_TIMEOUT_MS = 12_000;
